import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';
export default () => {
  const { colors } = useTheme();
  return {
    footerWrapper: css`
      color: white;
    `,
    top: css`
      background-color: #011e41;
      padding: 2.5rem;
      padding-bottom: 1.125rem;
    `,
    list: css`
      display: flex;
      gap: 1.5rem;
      flex-wrap: wrap;
      margin-bottom: 1.625rem;
      a {
        color: #f0f1f4;
        text-decoration: none;
        font-size: 14.2px;
        letter-spacing: 0.0019em;
        font-weight: normal;
        cursor: pointer;
      }
      span {
        display: none;
      }
      li:hover {
        text-decoration: underline;
      }
      li a{
        &:focus-visible {
          outline: none;
          border-bottom: 2px solid ${colors.border_black};
          color: ${colors.border_black};
          background-color: ${colors.skip_yellow};
          &:hover{
            text-decoration: underline;
            text-decoration-color: ${colors.border_black};
          }
        }
      }
    `,
    middle: css`
      color: white;
      position: relative;
    `,
    bottom: css`
      background-color: #20242c;
      font-family: FS Dillon;
      font-weight: 400;
      font-size: 12.6px;
      line-height: 16px;
      letter-spacing: 0.0019em;
      text-align: center;
      padding: 0.5rem 2.5rem;
    `,
    icons: css`
      display: flex;
      gap: 13.12px;
      justify-content: center;
      align-items: center;

      li {
        background-color: #011e41;
        z-index: 2;
      }
      ::after {
        flex: 1;
        content: '';
        background-color: #ffffff;
        height: 1px;
      }
      ::before {
        flex: 1;
        content: '';
        background-color: #ffffff;
        height: 1px;
      }
    `,
  };
};
